<template>
  <div style="padding: 20px">
    <h2>
      {{ $t('param.title') }}
    </h2>
    <div style="padding-left: 25%">
      <a-form-model layout="inline">
        <a-form-model-item class="mr" :label="$t('param.searchDevice')" style="width: 60%" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-select
            v-model="form.code"
            style="width: 105%"
            :placeholder="$t('param.deviceCode')"
            show-search
            :default-active-first-option="false"
            :show-arrow="true"
            :filter-option="false"
            :getPopupContainer="getPopupContainer"
            @inputKeydown="searchDevice"
          >
            <a-spin v-if="isDeviceLoading" slot="notFoundContent" size="small" />
            <a-select-option v-for="d in deviceList" :key="d.id" @click.native="selectDevice(d)">
              {{ d.code }} - {{ d.customer.company }} - {{ d.model }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <br />
        <a-form-model-item :label="$t('common.dtuCode')" style="width: 20%" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
          <a-input v-model="form.dtuCode" />
        </a-form-model-item>
      </a-form-model>
      <a-form-model layout="inline">
        <a-form-model-item :label="$t('param.writeOrRead')" style="width: 20%" :label-col="{ span: 7 }" :wrapper-col="{ span: 17 }">
          <a-radio-group
            v-model="form.io"
            @change="clearData"
          >
            <a-radio value="read">{{ $t('param.read') }}</a-radio>
            <a-radio value="write">{{ $t('param.write') }}</a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item v-show="form.io === 'write'" :label="$t('device.value')" style="width: 70%" :label-col="{ span: 2 }" :wrapper-col="{ span: 22 }">
          <a-input-number style="width: 50%;" v-model="form.value" :placeholder="$t('param.number')" />
        </a-form-model-item>
        <br />
        <a-form-model-item class="mr" style="width: 60%" :label="$t('param.selectParam')" :label-col="{ span: 2 }" :wrapper-col="{ span: 21 }">
          <a-select
            v-model="form.pointCode"
            style="width: 100%"
            :placeholder="$t('param.searchParam')"
            show-search
            :default-active-first-option="false"
            :show-arrow="true"
            :filter-option="false"
            :getPopupContainer="getPopupContainer"
            @inputKeydown="searchPoints"
          >
            <a-spin v-if="isPointLoading" slot="notFoundContent" size="small" />
            <a-select-option v-for="d in points" :key="d.code" @click.native="selectPoint(d)">
              {{ d.name }} - {{ d.startAddress }} - {{ d.registerCnt }} - {{ d.coefficient }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item class="mr" style="width: 60%" :label="$t('param.address')" :label-col="{ span: 2 }" :wrapper-col="{ span: 18 }">
          <a-input v-model="form.startAddress" style="width: 60%; margin-right: 15px" />
          <a-button :disabled="!(form.startAddress + '')" type="primary" @click="setText">{{ $t('param.createText') }}</a-button>
        </a-form-model-item>
        <a-form-model-item class="mr" style="width: 60%; position: relative" :label="$t('param.command')" :label-col="{ span: 2 }" :wrapper-col="{ span: 18 }">
          <a-select
            v-model="AT"
            style="width: 100%"
            :default-active-first-option="false"
            :show-arrow="true"
            :filter-option="false"
            :getPopupContainer="getPopupContainer"
          >
            <a-select-option v-for="a in ATS" :key="a.text"  @click.native="selectAT(a)">
              {{ a.text }} - {{ a.value }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item class="mr" style="width: 60%; position: relative" :label="$t('param.createContent')" :label-col="{ span: 2 }" :wrapper-col="{ span: 18 }">
          <a-textarea v-model="form.contentToSend" :auto-size="{ minRows: 2, maxRows: 5 }" />
          <a-checkbox v-model="isSendHex" style="position: absolute; width: 80px; right: -94px; top: -37px" @change="handleSendHChange">HEX</a-checkbox>
        </a-form-model-item>
        <a-form-model-item class="form_item_btn mr" style="width: 60%; margin: 0" :label="$t('param.createContent')" :label-col="{ span: 2 }" :wrapper-col="{ span: 18 }">
          <a-button :loading="isSending" :disabled="!form.contentToSend || !isSendHex" type="primary" @click="send" >{{ $t('param.send') }}</a-button>
        </a-form-model-item>
        <a-form-model-item class="mr" style="width: 60%; position: relative" :label="$t('param.returnedContent')" :label-col="{ span: 2 }" :wrapper-col="{ span: 18 }">
          <a-textarea v-model="form.content" :auto-size="{ minRows: 5, maxRows: 7 }" />
          <a-checkbox v-model="isGetHex" style="position: absolute; width: 80px; right: -94px; top: -100px" @change="setResult">HEX</a-checkbox>
        </a-form-model-item>
      </a-form-model>
    </div>
  </div>
</template>

<script>
import { searchDeviceList, writeCommand } from '@/api/device'
import { getProtocol } from '@/api/protocol'
import { getDict } from '@/api/dict'

const map = {
  '\\r': '\r',
  '\\n': '\n',
  '\\r\\n': '\r\n'
}

export default {
  data() {
    return {
      labelCol: {
        span: 2
      },
      wrapperCol: {
        span: 20
      },
      form: {
        code: '',
        dtuCode: '',
        io: 'read',
        pointCode: '',
        startAddress: '',
        contentToSend: '',
        value: '',
        content: ''
      },
      deviceList: [],
      isDeviceLoading: false,
      points: [],
      isPointLoading: false,
      isSendHex: true,
      isGetHex: true,
      isSending: false,
      AT: '',
      ATS: []
    }
  },
  created() {
    this.gHex = ''
    this.isTODOShow = process.env.NODE_ENV === 'development'
    this.getDict()
  },
  methods: {
    async getDict() {
      const { data } = await getDict('zh-CN', 'dtuRestartCommand')
      this.ATS = data.content
    },
    getPopupContainer(triggerNode) {
      return triggerNode.parentNode
    },
    async searchDevice({ target, code }) {
      if (code === 'Enter' || code === 'NumpadEnter') {
        target.value = target.value.trim()
        this.isDeviceLoading = true
        try {
          const { data } = await searchDeviceList(1, 20, {
            query: [
              {
                field: 'code',
                value: target.value
              }
            ],
            filter: [],
            sort: [
              {
                field: 'updatedAt',
                value: 'DESC'
              }
            ]
          })
          this.deviceList = data.records
        } catch(e) {
          console.log(e)
        } finally {
          this.isDeviceLoading = false
        }
      }
    },
    async selectDevice(d) {
      this.registerCnt = ''
      this.form.dtuCode = d.dtuCode
      this.form.pointCode = ""
      this.form.startAddress = ""
      this.AT = ""
      this.form.contentToSend = ""
      this.form.content = ""
      this.points = []
      try {
        this.isPointLoading = true
        const { data } = await getProtocol(d.protocolCode)
        this.points = this.originPoints = data.points.filter(d => d.dataWrite !== 2)
        this.deviceAddress = d.deviceAddress
      } catch(e) {
        console.log(e)
      } finally {
        this.isPointLoading = false
      }
    },
    searchPoints({ target, code }) {
      if (code === 'Enter' || code === 'NumpadEnter') {
        target.value = target.value.trim()
        this.isPointLoading = true
        this.points = this.originPoints.filter(o => o.name.includes(target.value))
        this.isPointLoading = false
      }
    },
    selectPoint(p) {
      this.form.startAddress = p.startAddress
      this.registerCnt = p.registerCnt
      this.readControlCode = p.readControlCode || "03"
      this.writeControlCode = p.writeControlCode || "06"
      this.clearData()
    },
    clearData() {
      this.originString = this.hexString = this.form.contentToSend = ''
      this.gHex = this.gDec = this.form.content = ''
      this.form.value = ''
      this.AT = ""
    },
    CRC16(b) {
      const bytes = b.match(/.{1,2}/g)
      const ret_byte = []
      let CRC = 0x0000ffff
      const POLYNOMIAL = 0x0000a001
      for (let i = 0; i < bytes.length; i++) {
        CRC ^= parseInt(bytes[i], 16)
        for (let j = 0; j < 8; j++) {
          if ((CRC & 0x00000001) === 1) {
            CRC >>= 1
            CRC ^= POLYNOMIAL
          } else {
            CRC >>= 1
          }
        }
      }
      CRC = ((CRC & 0x0000FF00) >> 8) | ((CRC & 0x000000FF) << 8)
      // HEX
      ret_byte[0] = ((CRC & 0x0000FF00) >> 8).toString(16)
      ret_byte[1] = (CRC & 0x000000FF).toString(16)
      // DEC
      ret_byte[2] = (CRC & 0x0000FF00) >> 8
      ret_byte[3] = (CRC & 0x000000FF)
      return ret_byte
    },
    setText() {
      if (this.form.io === 'read') {
        let registerCnt16 = this.addZero(this.registerCnt)
        registerCnt16 = registerCnt16 === '0000' ? '0001' : registerCnt16
        const CRCResult = this.CRC16(this.deviceAddress + this.readControlCode + (this.addZero((+this.form.startAddress).toString(16))) + this.addZero(registerCnt16))
        CRCResult[0] = CRCResult[0].length < 2 ? '0' + CRCResult[0] : CRCResult[0]
        CRCResult[1] = CRCResult[1].length < 2 ? '0' + CRCResult[1] : CRCResult[1]
        this.originString = (this.deviceAddress + this.readControlCode + this.addZero(+this.form.startAddress) + this.addZero(registerCnt16) + CRCResult[2] + CRCResult[3]).toUpperCase()
        this.hexString = (this.deviceAddress + this.readControlCode + (this.addZero((+this.form.startAddress).toString(16))) + this.addZero(registerCnt16) + CRCResult[0] + CRCResult[1]).toUpperCase()
      }
      if (this.form.io === 'write') {
        const CRCResult = this.CRC16(this.deviceAddress + this.writeControlCode + (this.addZero((+this.form.startAddress).toString(16))) + (this.addZero((+this.form.value).toString(16))))
        CRCResult[0] = CRCResult[0].length < 2 ? '0' + CRCResult[0] : CRCResult[0]
        CRCResult[1] = CRCResult[1].length < 2 ? '0' + CRCResult[1] : CRCResult[1]
        this.originString = (this.deviceAddress + this.writeControlCode + (this.addZero(+this.form.startAddress)) + (this.addZero(+this.form.value)) + CRCResult[2] + CRCResult[3]).toUpperCase()
        this.hexString = (this.deviceAddress + this.writeControlCode + (this.addZero((+this.form.startAddress).toString(16))) + (this.addZero((+this.form.value).toString(16))) + CRCResult[0] + CRCResult[1]).toUpperCase()
      }
      this.form.contentToSend = this.isSendHex ? this.hexString : this.originString
    },
    addZero(a) {
      const end = 4 - (a + '').length
      for (let i = 0; i < end; i++) {
        a = '0' + a
      }
      return a
    },
    handleSendHChange() {
      if (this.isSendHex) {
        this.transDToH(this.form.contentToSend)
        this.form.contentToSend = this.hexString
      } else {
        this.transHToD(this.form.contentToSend)
        this.form.contentToSend = this.originString
      }
    },
    async send() {
      this.isSending = true
      try {
        const { data } = await writeCommand({
          dtuCode: this.form.dtuCode,
          command: this.form.contentToSend.split(' ').join('')
        })
        this.$message.success(this.$t('messages.success'))
        this.gHex = data
        this.setResult()
      } catch(e) {
        console.log(e)
      } finally {
        this.isSending = false
      }
    },
    setResult() {
      // 将十六进制字符串转换为字节数组
      const bytes = [];
      for (var i = 0; i < this.gHex.length; i += 2) {
        bytes.push(parseInt(this.gHex.substr(i, 2), 16));
      }
      // 创建一个Uint8Array来存储字节
      const uint8Array = new Uint8Array(bytes);

      // 使用TextDecoder将字节转换为字符串
      const decoder = new TextDecoder('GBK');
      this.gDec = decoder.decode(uint8Array);
      this.form.content = this.isGetHex ? this.gHex : this.gDec
    },
    selectAT(a) {
      this.clearData()
      this.form.contentToSend = a.value
      this.handleSendHChange()
    },
    transDToH(string) {
      let hex = ''
      for (let i = 0; i < string.length; i++) {
        let char = string[i]
        if (string[i] === '\\') {
          char = '\\' + string[i + 1]
          i++
          char = map[char].charCodeAt().toString(16)
        } else {
          char = char.charCodeAt().toString(16)
        }
        char = char.length > 1 ? char : ('0' + char)
        hex += char
      }
      this.hexString = hex
    },
    transHToD(hexString) {
      if (hexString.startsWith('admin')) {
        this.originString = hexString
        return
      }
      let result = '';
      for (let i = 0; i < hexString.length; i += 2) {
        let hexCode = hexString.substr(i, 2);
        let decimalCode = parseInt(hexCode, 16);
        result += String.fromCharCode(decimalCode);
      }
      // this.originString = result.split('\r\n')
      // if (result.slice(-2, -1) === '\r') {
      //   this.originString = result.slice(0, -2) + '\\r'
      // }
      // if (result.slice(-1) === '\n') {
      //   this.originString += '\\n'
      // }
      result = result.split('')
      for (let i = result.length - 1; i > result.length - 3; i--) {
        if (result[i] === '\n') {
          result[i] = '\\n'
        }
        if (result[i] === '\r') {
          result[i] = '\\r'
        }
      }
      this.originString = result.join('')
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-form {
  .ant-form-item-label:nth-child(n + 3) {
    margin-right: 8px;
  }
  .ant-input-number {
    width: 25%;
  }
  .ant-form-item {
    margin: 20px 0;
  }
  .form_item_btn {
    .ant-form-item-label {
      opacity: 0;
    }
  }
  .mr {
    .ant-form-item-label {
      margin-right: 8px;
    }
  }
}
</style>